
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/delay';

export interface Instruction {
    id: string;
    content: string;

  }

  interface TokenResponse {
    token: string;

  }

@Injectable()
export class instructionService {

    private token: string;

  constructor(private http: HttpClient) {}





  // display particular instruction
  public displayInstruction(id): Observable<any> {

    var body = {
      id:id
    }
    const base = this.http.post('/users/display_instruction', body);
    const request = base.pipe(
      map((data: TokenResponse) => {

          return data;
      })
    );
    return request;
  }
}